import React, { useState, useEffect } from "react";
import IconInput from "../../../../styled-components/input/icon-input";
import {
  Input,
  InputGroup,
} from "../../../../styled-components/input/styles/input";
import { Text } from "../../../../styled-components/text";
import { defaultStyles } from "../../../../../constants/style-constants/utils";
import * as B from "../../../../styled-components/button";
import { PlusOutlined } from "@ant-design/icons";
import * as Style from "./styles/carry-forward";
import InflationRates from "../inflation-rates/inflation-rates";
import CapitalGains from "../capital-gains/capital-gains";
import { CarryForwadModal } from "./CarryForwadModal";
import NewLoader from "../../../../styled-components/loader/NewLoader";
import TAX_AND_INFLATION_API from "../../../../../apis/tax_and_inflation.api";
import swal from "sweetalert";
import { Button, DatePicker } from "antd";
import { SocialSecurityHardCodeFields } from "../../../../../newComponents/SocialSecurity/components/SocialSecurityHardCodeFields";
import { CarryForwadTaxModal } from "./CarryForwadTaxModal";
import moment from "moment";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
function CarryForward({ handleTaxInflationObject, nextForm, preForm, data }) {
  const uniqueKey = Object.keys(data.carryForward.data)[0];
  const carryForwardObj = data.carryForward.data[uniqueKey];
  const [addModalCarry, setAddModalCarry] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [formData, setFormData] = useState(null);

  const [addModalCarryTax, setAddModalCarryTax] = useState(false);
  const [dataListTax, setDataListTax] = useState([]);
  const [formDataTax, setFormDataTax] = useState(null);
  const [modalTitleTax, setModalTitleTax] = useState("Add CarryForward Tax");

  const [modalTitle, setModalTitle] = useState("Add CarryForward");
  const [loading, setLoading] = useState(false);

  const handleInputChnageTax = (name, value) => {
    setFormDataTax({
      ...formDataTax,
      [name]: value,
    });
  };

  const handleInputChnage = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const openModal = (data) => {
    setModalTitle("Edit CarryForward");
    setFormData(data);
    setAddModalCarry(true);
  };
  const openModalTax = (data) => {
    setModalTitleTax("Edit CarryForward Tax");
    setFormDataTax(data);
    setAddModalCarryTax(true);
  };
  const handleCancelAddModal = () => {
    setAddModalCarry(false);
    setFormData(null);
    setModalTitle("Add CarryForward");
  };
  const handleCancelAddModalTax = () => {
    setAddModalCarryTax(false);
    setFormDataTax(null);
    setModalTitleTax("Add CarryForward");
  };

  const handleSaveAddModal = async () => {
    console.log(formData);
    setAddModalCarry(false);
    if (modalTitle === "Add CarryForward") {
      try {
        let payload = {
          ...formData,
        };

        setLoading(true);
        let data = await TAX_AND_INFLATION_API.createCarryForward(payload);
        if (data && data.status === 200) {
          swal("Success", data.messageCode, "success");
          await getCarryForward();
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let payload = {
          ...formData,
          purchaseDate:
            formData.purchaseDate && new Date(formData.purchaseDate),
          saleDate: formData.saleDate && new Date(formData.saleDate),
          salePrice: formData.saleDate && +formData.salePrice,
          purchasePrice: formData.saleDate && +formData.purchasePrice,
          capitalGain: formData.saleDate && +formData.capitalGain,
        };
        const {
          clientId,
          createdAt,
          deleted,
          enable,
          updatedAt,
          ...filteredPayload
        } = payload;
        let data = await TAX_AND_INFLATION_API.updateCarryForward(
          filteredPayload
        );
        if (data && data.status === 200) {
          swal(
            "Success",
            "Carry Forward Asset Detail Updated Successfully.",
            "success"
          );
          await getCarryForward();
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setFormData(null);
    setModalTitle("Add CarryForward");
  };

  const deleteRow = (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this ?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        let payload = {
          id: id,
        };
        try {
          setLoading(true);
          let res = await TAX_AND_INFLATION_API.deleteCarryForwad(id);
          if (res && res.status === 200) {
            swal("Deleted!", "Your CarryForward has been deleted.", "success");
            await getCarryForward();
          }
          setLoading(false);
        } catch (error) {
          setLoading(false);
          console.log("error while updating CarryForward", error);
        }
      }
    });
  };

  const getTaxInflationDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchTaxInflationDetails();
      if (data && data.data) {
        //inflation details
        console.log("response==>", data.data);
        const taxInfoData = data.data[0];
        if (taxInfoData) {
          setFormDataTax(taxInfoData);
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Tax Inflation Details", error);
    }
  };

  const getCarryForward = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForward();
      if (data && data.data) {
        setDataList(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getCarryForwardTax = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.fetchCarryForwardTax();
      if (data && data.data) {
        setDataListTax(data.data.rows);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getAll = async () => {
    await getCarryForward();
    getTaxInflationDetails();
    // await getCarryForwardTax();
  };
  useEffect(() => {
    getAll();
  }, []);

  const carryForwardObjMain = {
    "Total Carry Forward": "50",
    "Short Term Carry Forward": "80",
    "Long Term Carry Forward": "10",
    "Carry Forward Updated": "800",
    "Carry Forward Loss Notes": "Sample Notes",
  };

  const [carryForwardData, setCarryForwardData] = useState({
    "Total Carry Forward":
      (carryForwardObj && carryForwardObj["Total Carry Forward"]) ||
      carryForwardObjMain["Total Carry Forward"],
    "Short Term Carry Forward":
      (carryForwardObj && carryForwardObj["Short Term Carry Forward"]) ||
      carryForwardObjMain["Short Term Carry Forward"],
    "Long Term Carry Forward":
      (carryForwardObj && carryForwardObj["Long Term Carry Forward"]) ||
      carryForwardObjMain["Long Term Carry Forward"],
    "Carry Forward Updated":
      (carryForwardObj && carryForwardObj["Carry Forward Updated"]) ||
      carryForwardObjMain["Carry Forward Updated"],
    "Carry Forward Loss Notes":
      (carryForwardObj && carryForwardObj["Carry Forward Loss Notes"]) ||
      carryForwardObjMain["Carry Forward Loss Notes"],
  });

  const { styles } = defaultStyles;

  const handleCarryForwardInfo = (obj) => {
    const { name, value } = obj;
    setCarryForwardData({
      ...carryForwardData,
      [name]: value,
    });
  };

  const nextComponent = {
    name: "inflationRates",
    title: "Inflation Rates",
    unique: "firstName",
    component: InflationRates,
    isMulti: true,
    inflationRates: {},
  };

  const preComponent = {
    name: "capitalGains",
    title: "Capital Gains",
    unique: "firstName",
    component: CapitalGains,
    isMulti: true,
    capitalGains: {},
  };

  const submitData = async () => {
    await handleSaveTaxInformation();
    handleTaxInflationObject(carryForwardData);
    nextForm(nextComponent);
  };
  const handleSaveTaxInformation = async () => {
    try {
      setLoading(true);
      // If id exists, include it to update, else save new
      let payload = {
        taxYear: formDataTax && formDataTax.taxYear ? formDataTax.taxYear : "",
        capitalLossCarryForward:
          formDataTax && formDataTax.capitalLossCarryForward
            ? Number(formDataTax.capitalLossCarryForward)
            : "",
      };
      if (formDataTax && formDataTax.id) {
        payload.id = formDataTax.id;
        await TAX_AND_INFLATION_API.updateTaxInflationDetails(payload);
      } else {
        await TAX_AND_INFLATION_API.saveTaxInflationDetails(payload);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("Error while saving/updating tax information:", error);
    }
  };
  const formFields = [
    {
      label: "Tax Year of Origin",
      type: "date",
      name: "taxYear",
    },
    {
      label: "Total Capital Loss Carryforward",
      type: "number",
      name: "capitalLossCarryForward",
    },
  ];

  return (
    <Style.MainContainer style={{ position: "relative" }}>
      <h3
        style={{
          color: "#2a3da3",
          fontWeight: "600",
          fontSize: "28px",
          display: "flex",
          alignItems: "baseline",
          columnGap: "3px",
        }}
      >
        Carry Forward
        <ToolTipCreator name="Tax_Carry_Forward" />
      </h3>
      <Style.MainFieldsContainer>
        <Style.FieldsContainer>
          <Style.FieldsContainer>
            <SocialSecurityHardCodeFields
              formFields={formFields && formFields}
              formData={formDataTax && formDataTax}
              onChange={handleInputChnageTax}
            />
          </Style.FieldsContainer>
        </Style.FieldsContainer>
      </Style.MainFieldsContainer>
      {addModalCarry && (
        <CarryForwadModal
          title={modalTitle && modalTitle}
          open={addModalCarry}
          handleChange={handleInputChnage}
          handleCancel={handleCancelAddModal}
          data={formData && formData}
          handleSave={handleSaveAddModal}
        />
      )}
      {/*addModalCarryTax && (
        <CarryForwadTaxModal
          title={modalTitleTax && modalTitleTax}
          open={addModalCarryTax}
          handleChange={handleInputChnageTax}
          handleCancel={handleCancelAddModalTax}
          data={formDataTax && formDataTax}
          handleSave={handleSaveAddModalTax}
        />
      ) */}

      <div
        style={{
          maxWidth: "1100px",
          width: "100%",
        }}
        className="inflation-carry-forward-table-container"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <B.Button
            style={styles.button.sqaureButton}
            onClick={() => setAddModalCarry(true)}
          >
            <PlusOutlined style={{ color: "#ffffff" }} />
          </B.Button>
        </div>
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            borderRadius: "16px",
            border: "2px solid #2A3DA3",
          }}
        >
          <table
            className="inflation-carry-forward-custom-table"
            style={{ border: "none" }}
          >
            <thead style={{ borderRadius: "0px" }}>
              <tr>
                <th style={{ borderTopLeftRadius: "13px" }}>
                  Source/Asset Sold
                </th>
                <th>Date Purchased</th>
                <th>Purchase Price</th>
                <th>Date Sold</th>
                <th>Sale Price</th>
                <th>Asset Type</th>
                <th>Commission & Fees</th>
                <th style={{ borderTopRightRadius: "13px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataList && dataList.length > 0 ? (
                dataList.map((item, index) => (
                  <tr key={index}>
                    <td>{item.asset ? item.asset : "N/A"}</td>
                    <td>
                      {item.purchaseDate
                        ? moment(item.purchaseDate).format("MMM DD, YYYY")
                        : "N/A"}
                    </td>
                    <td>
                      {item.purchasePrice
                        ? "$" +
                          parseFloat(item.purchasePrice)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "N/A"}
                    </td>
                    <td>
                      {item.saleDate
                        ? moment(item.saleDate).format("MMM DD, YYYY")
                        : "N/A"}
                    </td>
                    <td>
                      {item.salePrice
                        ? "$" +
                          parseFloat(item.salePrice)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "N/A"}
                    </td>
                    <td>{item.assetType ? item.assetType : "N/A"}</td>
                    <td>
                      {item.commissionAndFees
                        ? "$" +
                          parseFloat(item.commissionAndFees)
                            .toFixed(2)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        : "N/A"}
                    </td>
                    <td>
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          // gap: "1rem",
                        }}
                      >
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="edit"
                          onClick={() => openModal(item)}
                        ></Button>

                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="delete"
                          onClick={() => deleteRow(item.id)}
                        ></Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/*<div
        style={{
          maxWidth: "800px",
          width: "100%",
        }}
        className="inflation-carry-forward-table-container"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <B.Button
            style={styles.button.sqaureButton}
            onClick={() => setAddModalCarryTax(true)}
          >
            <PlusOutlined style={{ color: "#ffffff" }} />
          </B.Button>
        </div>
        <div
          style={{
            maxHeight: "300px",
            overflowY: "auto",
            borderRadius: "16px",
            border: "2px solid #2A3DA3",
          }}
        >
          <table
            className="inflation-carry-forward-custom-table"
            style={{ border: "none" }}
          >
            <thead style={{ borderRadius: "0px" }}>
              <tr>
                <th style={{ borderTopLeftRadius: "13px" }}>
                  Tax Return Filing Year
                </th>
                <th>Short Term/Long Term</th>
                <th>Amount of Carryforward Used</th>
                <th>Amount of Carryforward Remaining</th>
                <th style={{ borderTopRightRadius: "13px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {dataListTax && dataListTax.length > 0 ? (
                dataListTax.map((item, index) => (
                  <tr key={index}>
                    <td>{item.year ? moment(item.year).format("YYYY")  : "N/A"}</td>
                    <td>{item.term ? item.term : "N/A"}</td>
                    <td>{item.amountUsed ? "$" + parseFloat(item.amountUsed).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "N/A"}</td>
                    <td>{item.amountRemain ? "$" + parseFloat(item.amountRemain).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "N/A"}</td>
                    <td>
                      {" "}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          // gap: "1rem",
                        }}
                      >
                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="edit"
                          onClick={() => openModalTax(item)}
                        ></Button>

                        <Button
                          type="link"
                          style={{ fontSize: "21px" }}
                          icon="delete"
                          onClick={() => deleteRowTax(item.id)}
                        ></Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    style={{ textAlign: "center", padding: "10px" }}
                  >
                    No Data
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div> */}
      <Style.ButtonsContainer>
        <button
          className="tax-inflation-prev-button"
          onClick={() => preForm(preComponent)}
        >
          Previous
        </button>
        <button className="tax-inflation-next-button" onClick={submitData}>
          Next
        </button>
      </Style.ButtonsContainer>
      <NewLoader isLoading={loading} />
    </Style.MainContainer>
  );
}

export default CarryForward;
